import React from 'react';
import { DestinationPoint, TakeOffPoint } from './components';
import { ARC_MAP_EVENT, ArcMapEvent, ArcPolyline, DistanceLabel, getLocationFromMap } from '@src/core/controllers';
import { useDispatch, useSelector } from 'react-redux';
import { selectPath, setDestinationLocation } from './redux';
import { UpsertOrderMapProps } from './types';

const UpsertOrderMap: React.FC<UpsertOrderMapProps> = () => {
  const dispatch = useDispatch();
  const path = useSelector(selectPath);

  const onDblClick = async (e: google.maps.MapMouseEvent) => {
    const location = await getLocationFromMap(e);
    if (!location) return;
    dispatch(setDestinationLocation(location));
  };

  return (
    <React.Fragment>
      <TakeOffPoint />
      <DestinationPoint />
      <ArcPolyline.future path={path} />
      <DistanceLabel path={path}/>
      <ArcMapEvent 
        handler={onDblClick}
        eventName={ARC_MAP_EVENT.onDblClick} 
      />
    </React.Fragment>
  );
};

export default UpsertOrderMap;